export default Object.freeze({
  Audio: ['audio/mp3', 'audio/mpeg'],
  Image: ['image/jpeg', 'image/jpg', 'image/png'],
});
